// TODO IMPROVEMENT: Modify backend response for camelCase

export interface ISaveAuthorRequest {
  Name: string;
  Location: string;
}
export class SaveAuthorRequest implements ISaveAuthorRequest {
  constructor(
    public Name: string,
    public Location: string,
  ) {}
}
